// extracted by mini-css-extract-plugin
module.exports = {"lia-list":"TagList_lia-list__83Z3Y","lia-pager":"TagList_lia-pager__xs5cQ","lia-pager-icon":"TagList_lia-pager-icon__heTvM"};